import { Link } from "react-router-dom";
import OperatorInterface from "../../../interfaces/OperatorInterface";
import SectionInterface from "../../../interfaces/SectionInterface";
import NaviMenuSPOpenButton from "../../features/Navigation/NaviMenuSPOpenButton/index";
import HeaderAccount from "../HeaderAccount/index";
import styles from "./styles.scss";

interface Props {
  currentOperator: OperatorInterface;
  operators: OperatorInterface[];
  section: SectionInterface;
}

const SPGlobalHeader = (props: Props) => {
  return (
    <div className={styles.root}>
      <NaviMenuSPOpenButton />
      <div className={styles.logoWrap}>
        <Link to={`/sections/${props.section.id}`}>
          <img
            src="/images/logo.svg"
            className={styles.logo}
            alt="Studyplus for School"
          />
        </Link>
      </div>
      <HeaderAccount
        operators={props.operators}
        currentOperator={props.currentOperator}
      />
    </div>
  );
};

export default SPGlobalHeader;
